module.exports = __webpack_public_path__ + "media/images/basic_logos/setting-3f3160d63740f7b0704594d02954070c.svg";